// Base JavaScript dependencies
import './bootstrap';

// Set up global Vue resources
import './components';
import './filters';
import './plugins';

// Highcharts
import Highcharts from 'highcharts';
Highcharts.setOptions({
    lang: {
        thousandsSep: ',',
    },
});

// Set up the Vue app
import { sync } from 'vuex-router-sync';
import store from './store';
import router from './router';

sync(store, router);

const app = new Vue({
    el: '#app',
    store,
    router,
});

// Get site notifications
if (window.Laravel.user) {
    store.dispatch('data/subscribe', { channels: ['siteNotifications'] });
    store.dispatch('data/getActiveSiteNotifications');
}

window.app = app;
window.store = store;
window.router = router;
